
import { Vue, Prop, Component } from 'vue-property-decorator';
import store from "../../../core/store";
import { DateHelper } from "../../../core/helpers/dateHelper";
import { Product } from "@shared/core/interfaces/product";
import { Format } from "@shared/core/helpers/formatHelper";

@Component
export default class ActivityCard extends Vue {
  @Prop() activityWithParticipants!: any;
  @Prop() index!: number;
  @Prop({ required: false, default: -1 }) currentIndex!: number;
  private images: any[] = [];


  get little() {
    return this.currentIndex === -1 ? false : this.index !== this.currentIndex;
  }

  mounted(){
    this.setDefaultImages();
  }

  private setDefaultImages() {
    const context = require.context(
      "@/images/activities",
      false,
      /\.(png|jpe?g|webp|gif)$/
    );
    this.images = context.keys().map(context);
  }

  getActivityParticipants(activity: any) {
    const participants = activity.participants || [];
    return participants.length === 0
      ? [{}]
      : participants.length < 4
        ? participants
        : participants.slice(0, 4);
  }


  buildUrlActivity(activity: any) {
    return `/activity/${activity.id}`;
  }

  getImageActivity(name: string, index: number) {
    if (name !== undefined && name !== "" && name !== null) {
      return store.state.settings.Uploads + "/" + name;
    }
    return this.images[index % this.images.length];
  }

  getImageType(logo: string) {
    if (logo !== undefined && logo !== "" && logo !== null) {
      return store.state.settings.Uploads + "/" + logo;
    }
  }

  private getPrice(pr: Product) {
    if(pr == null) return "";
    const price = store.state.settings.PriceWithTaxes
      ? pr.grossPrice
      : pr.netPrice;
    return Format.formatCurrency(price.toString());
  }

  formatParticipants(activity: any) {
    const count = activity.participants?.length ?? 0;
    const max = activity.activity?.maxNumberOfParticipants;
    return max ? `${count}/${max}` : count;
  }

  formatDate(date: string) {
    const d: any = DateHelper.toDate(
      date,
      DateHelper.systemFormat
    );

    const sdate = DateHelper.toServerFormat(d);
    return DateHelper.beautifyDate(sdate, true, true, true, false);
  }

  formatHours(date: string) {
    const d: any = DateHelper.toDate(date, DateHelper.systemFormat);
    const hours = d.getHours();
    const minutes = d.getMinutes();
    if (hours === 0 && minutes === 0) {
      return "";
    }
    return DateHelper.extractTime(date);
  }

  getBrText(key: string) {
    const text = this.$t(key) as string;
    const parts = text.split(' ');
    return parts.length > 1 ? `${parts[0]}<br>${parts.slice(1).join(' ')}` : text;
  }
}
